import { jsx as Emotion } from '@emotion/react';
import { createElement } from 'react';
import { CLASSNAME_OVERRIDE_MAP } from '../constants';

export const createElementOverride = (
    tagname: string,
    props: JSX.IntrinsicAttributes & { children?: JSX.Element[] }
): Emotion.JSX.Element => {
    const { children } = props || {};
    if (
        !children ||
        children.length === 0 ||
        !CLASSNAME_OVERRIDE_MAP[tagname]
    ) {
        return null;
    }

    return createElement(
        tagname,
        { className: CLASSNAME_OVERRIDE_MAP[tagname] },
        children
    );
};

export default createElementOverride;
